// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"styles_pageContainer__6h5wb","container":"styles_container__1yAPe","heading":"styles_heading__mQoP4","spinner":"styles_spinner__1sSVC"};